import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  PrescriptionForm,
  PrescriptionFormList,
  PrescriptionFormListAPI,
} from '../models/prescriptionForm/prescriptionForm';
import { PatientList, PatientListAPI } from '../models/patient';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionFormService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private apiUrl = `${environment.api.gateway}prescriptions-forms`;

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  pullList(
    nir?: string,
    nomPrenom?: string,
    codeDActivite?: string,
    page?: number,
    per_page?: number,
  ): Observable<PrescriptionFormList> {
    const headers = this.getHeaders();

    let params: HttpParams = new HttpParams();
    if (nir) params = params.append('nir', nir);
    if (nomPrenom) params = params.append('nom_prenom', nomPrenom);
    if (codeDActivite) params = params.append('code_d_activite', codeDActivite);
    if (page) params = params.append('page', page);
    if (per_page) params = params.append('per_page', per_page);

    return this.http
      .get<PrescriptionFormListAPI>(this.apiUrl, {
        headers: headers,
        params: params,
      })
      .pipe(
        map((prescriptionFormListAPI: PrescriptionFormListAPI) =>
          PrescriptionFormList.factory(prescriptionFormListAPI),
        ),
      );
  }

  pdf(id: number): Observable<Blob> {
    const headers = this.getHeaders();

    return this.http.get(`${this.apiUrl}/${id}/pdf`, {
      headers: headers,
      responseType: 'blob',
    });
  }

  recapitulatif(id: number): Observable<Blob> {
    const headers = this.getHeaders();

    return this.http.get(`${this.apiUrl}/${id}/recapitulatif`, {
      headers: headers,
      responseType: 'blob',
    });
  }

  push(prescriptionForm: PrescriptionForm): Observable<any> {
    const headers = this.getHeaders();

    return this.http.post(this.apiUrl, prescriptionForm.toAPI(), {
      headers: headers,
    });
  }

  pushMass(data: {
    ppc_ordonnance?: number[];
    ppc_ordoclic?: number[];
    ppc_dap?: number[];
    dep?: number[];
    avf_ordonnance?: number[];
    aerosol_ordonnance?: number[];
  }): Observable<any> {
    const headers = this.getHeaders();

    return this.http.post(`${this.apiUrl}/mass`, data, {
      headers: headers,
    });
  }

  delete(prescriptionForm: PrescriptionForm): Observable<any> {
    if (prescriptionForm.id == undefined) return new Observable();

    const headers = this.getHeaders();

    return this.http.delete(`${this.apiUrl}/${prescriptionForm.id}`, {
      headers: headers,
    });
  }
}
